export const PORTAL_ROUTE = '/portal';
export const PASSWORD_RESET_ROUTE = '/passwordReset';
export const WDAC_ROUTE = '/portal/wdac-results/win32-apps';
